import { Flex } from '@chakra-ui/react';
import React from 'react';
import { useIsMobile } from '#hooks/useIsMobile';
import { NavDrawer, NavSideBar } from './components';

export const MainLayout = ({ children }) => {
  const isMobile = useIsMobile();

  return (
    <Flex width="full" height="100vh" flexDirection={isMobile ? 'column' : 'row'}>
      {isMobile ? <NavDrawer /> : <NavSideBar />}
      {children}
    </Flex>
  );
};
